import { DataReactionSourceEntity } from '@osos/shared/api';
import {
  EventExecutorTypeEnum,
  EventTypeEnum,
  TriggerSpaceScopeEnum,
  TriggerType,
} from '../enums';
import { FilterExpressionModel } from '../filter-expression.model';
import { LocalizedValueModel } from '../localized-value.model';
import { RefProperty } from '../ref-property.model';
import { DataEntityActionPresenterModel } from './data-entity-action-presenter.model';

export class DataReactionWithRelationsPresenterModel {
  id?: string;
  name: LocalizedValueModel;
  eventType: EventTypeEnum;
  criteria?: FilterExpressionModel;
  eventConfig?: { [key: string]: any };
  isImplicit?: boolean;
  disabled?: boolean;
  query?: string;
  spaceScope: TriggerSpaceScopeEnum;
  loopThreshold?: number;
  executorType: EventExecutorTypeEnum;
  sourceEntity?: DataReactionSourceEntity;
  type: TriggerType;
  actions: Array<DataEntityActionPresenterModel>;
  creationInfo?: {
    doneAt: string;
    doneBy: RefProperty;
  };
  updateInfo?: {
    doneAt: string;
    doneBy: RefProperty;
  };
  definingEntity?: RefProperty;

  specificationVersion: number;
  updateIdentifier?: string;
}
